import { Component, OnInit, ViewChild, viewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Group, GroupField } from '../app.types';
import { AuthFormPage } from '../auth-form/auth-form.page';
import { IonNav } from "@ionic/angular/standalone";
import { AuthFieldsPage } from './auth-fields/auth-fields.page';
import { ApiService } from '../api.service';

@Component({
  selector: 'app-auth-nav',
  templateUrl: './auth-nav.page.html',
  styleUrls: ['./auth-nav.page.scss'],
  standalone: true,
  imports: [IonNav, CommonModule, FormsModule]
})
export class AuthNavPage implements OnInit {

  groupFields: GroupField[]
  group: Group
  firebaseUid: string
  fromMenu = true

  @ViewChild("nav", { static: true }) nav: IonNav

  constructor(private api: ApiService) { }

  async ngOnInit() {
    if (this.group.custom_privacy) {
      this.nav.push(AuthFormPage, {
        groupFields: this.groupFields,
        group: this.group,
        firebaseUid: this.firebaseUid,
        fromMenu: this.fromMenu
      })
    } else {
      
      this.nav.push(AuthFieldsPage, {
          groupFields: this.groupFields,
          group: this.group,
          firebaseUid: this.firebaseUid
        })
    }

  }

}
